
import Card from 'vux/src/components/card/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {encrypt, decrypt} from '@/utils/jsencrypt'

export default {
components: {
Card,
XInput,
Toast,
XButton,
Divider
},
name: 'login',
data() {
return {
flag: false,
loginForm: {
username: "",
password: "",
rememberMe: false
},
}
},
created() {
let rememberMe = !!localStorage.getItem('rememberMe');
this.loginForm.rememberMe = !!rememberMe;
console.log(localStorage.getItem('rememberMe'), '99');
if (this.loginForm.rememberMe) {
this.loginForm.username = localStorage.getItem('username');
this.loginForm.password = decrypt(localStorage.getItem('password'));
console.log(this.loginForm.username, 'username');
} else {
this.loginForm.username = '';
this.loginForm.password = '';
}
},
mounted: function () {

},
methods: {
async loginSub() {
this.$store.dispatch("Login", this.loginForm).then(() => {
const that = this;
this.$vux.toast.show({
text: '登陆成功',
onShow() {
if (that.loginForm.rememberMe) {
localStorage.setItem('username', that.loginForm.username);
localStorage.setItem('password', encrypt(that.loginForm.password));
localStorage.setItem('rememberMe', that.loginForm.rememberMe);
} else {
localStorage.removeItem('username')
localStorage.removeItem('password')
localStorage.removeItem('rememberMe')
}
},
onHide() {
that.$router.push('/device');
}
});
}).catch(error => {
console.log(error, "loginSub error");
this.$vux.toast.show({
type: 'warn',
text: '登陆失败'
})
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/login.vue